import { loadLanguage, loadRegion } from 'state/intl/hook';

export const loadLocale = () => {
  const [language, region] = [loadLanguage(), loadRegion()];
  return { language, region };
};
